import type { AuditOutcomesFetchedAction } from '@Application/AuditTrail/Actions/auditOutcomesFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AuditOutcomesStore = {
	auditOutcomes: readonly LabeledValueView[] | null;
};

const initialState: AuditOutcomesStore = {
	auditOutcomes: null,
};

type Actions = AuditOutcomesFetchedAction | UserRevokedAction;

const whenAuditOutcomesFetched = (
	store: AuditOutcomesStore,
	action: AuditOutcomesFetchedAction,
): AuditOutcomesStore => ({
	...store,
	auditOutcomes: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): AuditOutcomesStore => initialState;

export default registerStore<'auditOutcomesStore', Actions>(
	'auditOutcomesStore',
	createSliceReducer({
		AUDIT_OUTCOMES_FETCHED: whenAuditOutcomesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
